import axios, { AxiosResponse } from 'axios';

export const getCountries = (
  cancelToken?: AbortSignal,
): Promise<AxiosResponse<string[]>> =>
  axios.get(`/api/countries`, {
    signal: cancelToken,
  });
